module.exports = __webpack_public_path__ + "assets/imgs/logos/appleSearchAds.2095b6d932fe54fe7fdc15a66f5a2cbc.svg";